import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=7152f0d0&scoped=true"
import script from "./SmsList.vue?vue&type=script&lang=js"
export * from "./SmsList.vue?vue&type=script&lang=js"
import style0 from "./SmsList.vue?vue&type=style&index=0&id=7152f0d0&prod&lang=scss&scoped=true"
import style1 from "./SmsList.vue?vue&type=style&index=1&id=7152f0d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7152f0d0",
  null
  
)

export default component.exports